var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('UserSignUp',{attrs:{"user_signup_token":_vm.user_signup_token,"require_tos_scroll":true,"tos_text":_vm.tos_text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }